<template>
  <form
    class="rep-detail"
    @submit.prevent="onSubmit"
  >
    <div class="columns is-multiline">
      <div class="column is-12">
        <RelatedDocumentDetails
          ref="RelatedDocumentDetailsComponent"
          :disabled="isLoading || stamped"
          :is-loading="isLoading"
          :inline="true"
        />
      </div>

      <div class="column is-12">
        <Payments
          v-if="paymentsLoaded"
          :disabled="isLoading || stamped"
          :is-loading="isLoading"
        />
      </div>

      <div class="column is-12">
        <CfdisRelatedReplacement
          replacement-type="replacementRep"
          :disabled="isLoading || stamped"
        />
      </div>

      <div class="column is-12 action-buttons">
        <div
          v-if="stamped || canceled"
          class="field is-grouped"
        >
          <p
            v-if="stamped && !canceled"
            class="control"
          >
            <a
              class="button is-info"
              :class="{ 'is-loading': isLoading }"
            >
              Complemento de Pago Timbrado
            </a>
          </p>
          <p
            v-if="canceled"
            class="control"
          >
            <a
              class="button is-danger"
              :class="{ 'is-loading': isLoading }"
            >
              Complemento de Pago Cancelado
            </a>
          </p>
          <p class="control">
            <RouterLink
              class="button"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              :to="{ name: 'RepList' }"
            >
              Regresar
            </RouterLink>
          </p>
        </div>
        <div
          v-else
          class="field is-grouped"
        >
          <p class="control">
            <button
              class="button is-primary"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              @click="setStamp(false)"
            >
              Guardar
            </button>
          </p>
          <p class="control">
            <button
              class="button is-success"
              type="submit"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              @click="setStamp(true)"
            >
              Guardar y Timbrar
            </button>
          </p>
          <p class="control">
            <RouterLink
              class="button"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              :to="{ name: 'RepList', query: { size: 20, page: 1 } }"
            >
              Regresar
            </RouterLink>
          </p>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'NewRep',
  components: {
    RelatedDocumentDetails: () => import(/* webpackChunkName: "new-document-related" */ '@/components/Admin/Invoices/NewDocumentRelated/DocumentRelatedDetails.vue'),
    Payments: () => import(/* webpackChunkName: "new-complement-payments" */ '@/components/Admin/Invoices/NewDocumentRelated/NewComplementPayments.vue'),
    CfdisRelatedReplacement: () => import(/* webpackChunkName: "cfdis-related-replacement" */ '@/components/Admin/CFDI/CfdisRelatedReplacement.vue'),
  },
  data() {
    return {
      isLoading: false,
      stamp: false,
      paymentsLoaded: false,
    };
  },
  computed: {
    ...mapState({
      stamped: state => state.invoice.operation.stamped,
      status: state => state.invoice.operation.status,
    }),
    canceled() {
      return [201, 202].includes(this.status);
    },
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getInvoiceByUuid(this.$route.params.uuid);
    if (!this.stamped) {
      this.setValue({
        accessor: 'voucherDate',
        value: moment().format('YYYY-MM-DDTHH:mm'),
      });
    }
    this.isLoading = false;
    this.paymentsLoaded = true;
  },
  methods: {
    ...mapMutations({
      setValue: 'invoice/setValue',
      setInitialState: 'invoice/setInitialState',
    }),
    ...mapActions({
      getInvoiceByUuid: 'invoice/getByUuid',
      updateInvoice: 'invoice/updateByUuid',
    }),
    setStamp(value) {
      this.stamp = value;
    },
    async onSubmit() {
      this.isLoading = true;

      const { stamp } = this;

      try {
        await this.updateInvoice({
          uuid: this.$route.params.uuid,
          stamp,
        });

        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: stamp ? 'Timbrado exitoso' : 'Guardado correctamente',
        });

        this.isLoading = false;

        this.setInitialState();

        this.$router.push({ name: 'InvoicesHistory' });
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: stamp
            ? error.message
            : 'Ocurrio un error al guardar.',
        });
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.rep-detail {
  padding: 1rem;
}
.action-buttons {
  display: flex;
  justify-content: flex-end;
}

@media screen and (min-width: 1280px) {
  .box {
    flex-direction: column;
  }

  .label.is-centered::before {
    top: inherit;
  }
}
</style>
